import { Link } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import './CreditHoldBanner.css'
import { CustomerState } from '../redux/customer'
import { ChildCustomerState } from '../redux/childCustomer'

interface CreditHoldBannerProps {
  customer: CustomerState | ChildCustomerState
}

const CreditHoldBanner = (props: CreditHoldBannerProps) => {
  const { customer } = props

  const openContactLink = async () => {
    window.open('https://www.healthfirst.com/customer-support/', '_blank')
  }

  return customer.customerMetadata?.credit_hold && (customer.corporate_parent || !customer.is_bill_to_parent) &&  (
    <div className="banner credit-hold-banner">
      <FontAwesomeIcon color='white' style={{ marginRight: '10px' }} icon={faExclamationTriangle} className="shipment-alerts-icon" />
      <span className="banner-text">There's an outstanding balance on your account that could affect upcoming auto shipments. 
        Please make a payment to keep your orders moving without interruption or <Link className="text-link" onClick={openContactLink}>contact us</Link> for more information.
      </span>
    </div>
  )
}

export default CreditHoldBanner